{
  "pegasus-einstein": {
    "config_id": "pegasus-einstein",
    "name": "Pegasus Einstein",
    "landingPage": "/pegasus-einstein",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/pegasus-einstein/einstein.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/pegasus-einstein/einstein-transparent.svg",
    "headerMobileLogo": "assets/tenant-assets/mini-env/pegasus-einstein/einstein-mobile.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/pegasus-einstein/einstein-mobile-transparent.svg",
    "headerPhoneNumber": "+844-969-4325",
    "footerLogo": "assets/tenant-assets/mini-env/pegasus-einstein/footer.svg",
    "facebookLink": "https://www.facebook.com/WoW-Health-Solutions-LLC-307406953311610",
    "linkedinLink": "https://www.linkedin.com/company/wow-health-solutions",
    "twitterLink": "https://twitter.com/pegasuseinstein",
    "discountAmount": 30,
    "purchasePageUrl": "pegasus-einstein/#membership-section",
    "headerLogoWidth": 265,
    "headerLogoWidthMob": 148,
    "membershipPlanTypes": "WOW_PLUS_MEMBERSHIP",
    "primaryButtonColor": "#fb8f3f",
    "primaryButtonText": "Sign Up",
    "primaryButtonLink": "/pegasus-einstein/#membership-section",
    "isSecondaryButtonDesign": true,
    "secondaryButtonColor": "#fb8f3f",
    "secondaryButtonText": "Member Login",
    "secondaryButtonLink": "/auth/login",
    "forcesDefaultLoginLogos": true
  },
  "whataburger": {
    "name": "What a burger",
    "config_id": "whataburger",
    "employer_id": "9119-0086-8090",
    "landingPage": "/whataburger",
    "headerPhoneNumber": "+844-969-4325",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/whataburger/whataburger.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/whataburger/whataburger-transparent.svg",
    "headerMobileLogo": "assets/tenant-assets/mini-env/whataburger/whataburger-mobile.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/whataburger/whataburger-mobile-transparent.svg",
    "footerLogo": "assets/tenant-assets/mini-env/whataburger/footer.svg",
    "facebookLink": "https://www.facebook.com/whataburger",
    "linkedinLink": "https://www.linkedin.com/company/whataburger",
    "twitterLink": "https://twitter.com/whataburger",
    "membershipPlanTypes": "",
    "purchasePageUrl": "whataburger/#pricing-for-wow-plus-membership",
    "headerLogoWidth": 287,
    "headerLogoWidthMob": 148,
    "primaryButtonColor": "#fb8f3f",
    "primaryButtonText": "Sign Up",
    "primaryButtonLink": "whataburger/#pricing-for-wow-plus-membership",
    "isSecondaryButtonDesign": true,
    "secondaryButtonColor": "#fb8f3f",
    "secondaryButtonText": "Member Login",
    "secondaryButtonLink": "/auth/login",
    "forcesDefaultLoginLogos": true
  },
  "acawellness": {
    "name": "Aca wellness",
    "config_id": "acawellness",
    "agent_id": "6119-4597-9944",
    "agency_id": "5119-4356-4078",
    "removeButtonsAfterLogin": true,
    "landingPage": "/acawellness",
    "headerPhoneNumber": "+844-969-4325",
    "headerDesktopLogologin": "assets/tenant-assets/mini-env/acawellness/aca-logo-login.svg",
    "headerDesktopLogoTransparentlogin": "assets/tenant-assets/mini-env/acawellness/aca-tr-logo-login.svg",
    "headerMobileLogoLogin" : "assets/tenant-assets/mini-env/acawellness/aca-mb-logo-login.svg",
    "headerMobileLogoTransparentLogin" : "assets/tenant-assets/mini-env/acawellness/aca-mb-tr-logo-login.svg",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/acawellness/aca-wellness.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/acawellness/aca-wellness-transparent.svg",
    "headerMobileLogo": "assets/tenant-assets/mini-env/acawellness/acawellness-mobile.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/acawellness/acawellness-mobile-transparent.svg",
    "footerLogo": "assets/tenant-assets/mini-env/whataburger/footer.svg",
    "facebookLink": "https://www.facebook.com/WoW-Health-Solutions-LLC-307406953311610",
    "linkedinLink": "https://www.linkedin.com/company/wow-health-solutions",
    "twitterLink": "https://twitter.com/WoWHealthPlan1",
    "primaryButtonText": "Login",
    "primaryButtonLink": "/auth/login",
    "membershipPlanTypes": "",
    "primaryColor": "#152177",
    "primaryColorLight": "#F2F4F6",
    "secondaryColor": "#042246",
    "headerLogoWidthLogin" : 300,
    "headerLogoWidthMobLogin" : 200,
    "headerLogoWidth": 170,
    "headerLogoWidthMob": 148,
    "primaryButtonColor": "#042246",
    "purchasePageUrl": "/acawellness",
    "backgroundColor": "#f3f6fb",
    "iconBackgroundColor": "rgba(233, 246, 255, 1)",
    "iconTextColor": "rgba(4, 34, 70, 1)",
    "bannerBackgroundColor": "rgba(233, 246, 255, 1)",
    "bannerTextColor": "rgba(0, 0, 0, 1)",
    "iconForeground": "rgba(64, 148, 208, 0.05)",
    "hideAicpaIcon": true,
    "hidePciComplaint": true,
    "isWalkerPharmacy": true
  },
  "perfectpizzapie-health-benefits": {
    "config_id": "perfectpizzapie-health-benefits",
    "headerPhoneNumber": "+844-969-4325",
    "landingPage": "/perfectpizzapie-health-benefits",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/perfect-pizza/perfect-pizza.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/perfect-pizza/tranparent-logo.svg",
    "headerMobileLogo": "assets/tenant-assets/mini-env/perfect-pizza/transparent-responcive.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/perfect-pizza/responcive.svg",
    "footerLogo": "assets/tenant-assets/images/einstein-footer.png",
    "facebookLink": "https://www.facebook.com/WoW-Health-Solutions-LLC-307406953311610",
    "twitterLink": "https://twitter.com/WoWHealthPlan1",
    "linkedinLink": "https://www.linkedin.com/company/wow-health-solutions",
    "purchasePageUrl": "perfectpizzapie-health-benefits/#pricing-for-wow-plus-membership",
    "membershipPlanTypes": "WOW_PLUS_MEMBERSHIP,COMPREHENSIVE_CARE_H2U_MEMBERSHIP",
    "headerLogoWidth": 287,
    "headerLogoWidthMob": 170,
    "primaryButtonColor": "#fb8f3f",
    "primaryButtonText": "Sign Up",
    "primaryButtonLink": "perfectpizzapie-health-benefits/#pricing-for-wow-plus-membership",
    "isSecondaryButtonDesign": true,
    "secondaryButtonColor": "#fb8f3f",
    "secondaryButtonText": "Member Login",
    "secondaryButtonLink": "/auth/login",
    "forcesDefaultLoginLogos": true

  },
  "parker-hospitality": {
    "config_id": "parker-hospitality",
    "landingPage": "/parker-hospitality",
    "headerPhoneNumber": "844-969-4325",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/parker-hospitality/parker-hospitality-logo.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/parker-hospitality/parker-hospitality-logo-transparent.svg",
    "headerMobileLogo": "assets/tenant-assets/mini-env/parker-hospitality/parker-hospitality-logo-mobile.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/parker-hospitality/parker-hospitality-logo-mobile-transparent.svg",
    "footerLogo": "assets/tenant-assets/images/einstein-footer.png",
    "facebookLink": "https://www.facebook.com/WoW-Health-Solutions-LLC-307406953311610",
    "twitterLink": "https://twitter.com/WoWHealthPlan1",
    "linkedinLink": "https://www.linkedin.com/company/wow-health-solutions",
    "discountAmount": 30,
    "membershipCodes": "WOW_PLUS_H2U_MEMBERSHIP,COMPREHENSIVE_CARE_H2U_MEMBERSHIP",
    "purchasePageUrl": "parker-hospitality/#pricing-for-wow-plus-membership",
    "headerLogoWidth": 274,
    "headerLogoWidthMob": 160,
    "primaryButtonColor": "#fb8f3f",
    "primaryButtonText": "Sign Up",
    "primaryButtonLink": "parker-hospitality/#pricing-for-wow-plus-membership",
    "isSecondaryButtonDesign": true,
    "secondaryButtonColor": "#fb8f3f",
    "secondaryButtonText": "Member Login",
    "secondaryButtonLink": "/auth/login",
    "forcesDefaultLoginLogos": true
  },
  "aquoral": {
    "config_id": "aquoral",
    "landingPage": "/aquoral",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/aquoral/aquoral-logo.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/aquoral/aquoral-transparent-logo.svg",
    "headerMobileLogo": "assets/tenant-assets/mini-env/aquoral/aquoral-logo.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/aquoral/aquoral-transparent-logo.svg",
    "headerPhoneNumber": "+813-680-4232",
    "footerLogo": "assets/tenant-assets/images/einstein-footer.png",
    "facebookLink": "https://www.facebook.com/WoW-Health-Solutions-LLC-307406953311610",
    "twitterLink": "https://twitter.com/WoWHealthPlan1",
    "linkedinLink": "https://www.linkedin.com/company/wow-health-solutions",
    "discountAmount": 30,
    "membershipCodes": "",
    "membershipPlanTypes": "WOW_BASIC_AQUORAL_H2U_MEMBERSHIP",
    "purchasePageUrl": "aquoral/#pricing-for-wow-plus-membership",
    "primaryButtonColor": "#FB8F3F",
    "primaryButtonText": "Sign Up",
    "primaryButtonLink": "aquoral/#pricing-for-wow-plus-membership",
    "secondaryButtonColor": "#FB8F3F",
    "secondaryButtonText": "Member login",
    "secondaryButtonLink": "/auth/login",
    "isSecondaryButtonDesign": true,
    "headerLogoWidth": 168,
    "forcesDefaultLoginLogos": true,
    "variants":{"LAASY_HEALTH_REWARDS": "LaaSy Health Rewards"}
  },
  "hub-international": {
    "config_id": "hub-international",
    "name": "Hub International",
    "landingPage": "/hub-international",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/hub-international/hub-international-logo.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/hub-international/hub-international-logo-transparent.svg",
    "headerMobileLogo": "assets/tenant-assets/mini-env/hub-international/hub-international-logo-mobile.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/hub-international/hub-international-logo-transparent-mobile.svg",
    "headerPhoneNumber": "+844-969-4325",
    "footerLogo": "assets/tenant-assets/mini-env/pegasus-einstein/footer.svg",
    "facebookLink": "https://www.facebook.com/WoW-Health-Solutions-LLC-307406953311610",
    "twitterLink": "https://twitter.com/WoWHealthPlan1",
    "linkedinLink": "https://www.linkedin.com/company/wow-health-solutions",
    "membershipCodes": "Wow_Plus_Membership_Monthly,Wow_Plus_Membership_Yearly",
    "purchasePageUrl": "hub-international/#searchBox",
    "primaryButtonColor": "#FB8F3F",
    "primaryButtonText": "Sign Up",
    "primaryButtonLink": "hub-international/#searchBox",
    "secondaryButtonColor": "#FB8F3F",
    "secondaryButtonText": "Member login",
    "secondaryButtonLink": "/auth/login",
    "isSecondaryButtonDesign": true,
    "headerLogoWidth": 250,
    "headerLogoWidthMob": 148,
    "forcesDefaultLoginLogos": true
  },
  "ssp": {
    "config_id": "ssp",
    "name": "Script Saver",
    "employer_id": "9119-7860-5889",
    "landingPage": "/ssp",
    "isEligibility": true,
    "removeButtonsAfterLogin": true,
    "headerDesktopLogologin": "assets/tenant-assets/mini-env/ssp/script-sever-logo-login.svg",
    "headerDesktopLogoTransparentlogin": "assets/tenant-assets/mini-env/ssp/ssp-tr-login.svg",
    "headerMobileLogoLogin" : "assets/tenant-assets/mini-env/ssp/ssp-mb-login.svg",
    "headerMobileLogoTransparentLogin" : "assets/tenant-assets/mini-env/ssp/ssp-tr-mb-login.svg",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/ssp/ssp-logo.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/ssp/ssp-logo-transparent.svg",
    "headerMobileLogo": "assets/tenant-assets/mini-env/ssp/ssp-logo.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/ssp/ssp-logo-transparent-mobile.svg",
    "footerLogo": "assets/tenant-assets/mini-env/pegasus-einstein/footer.svg",
    "facebookLink": "https://www.facebook.com/WoW-Health-Solutions-LLC-307406953311610",
    "twitterLink": "https://twitter.com/WoWHealthPlan1",
    "linkedinLink": "https://www.linkedin.com/company/wow-health-solutions",
    "membershipCodes": "Wow_Plus_Membership_Monthly",
    "primaryColor": "#4094D0",
    "primaryColorLight": "#E9F6FF",
    "primaryOutlineColor": "#D7ECFA",
    "purchaseURL": "",
    "backgroundColor": "#f3f6fb",
    "checkLogo": "assets/tenant-assets/mini-env/ssp/check-logo.svg",
    "secondaryColor": "#4094D0",
    "headerLogoWidthLogin" : 300,
    "headerLogoWidthMobLogin" : 200,
    "headerLogoWidth": 179,
    "headerLogoWidthMob": 144,
    "headerPhoneNumber": "+844-969-4325",
    "secondaryButtonColor": "#4094D0",
    "secondaryButtonText": "Login",
    "secondaryButtonLink": "/auth/login",
    "primaryButtonColor": "#4094D0",
    "primaryButtonText": "Sign Me Up",
    "primaryButtonLink": "https://www.getcadrplus.com/order/checkout.cfm?id=65430&pdid=43663",
    "iconBackgroundColor": "rgba(186, 217, 239, 0.6)",
    "iconTextColor": "rgba(61, 150, 209, 1)",
    "iconForeground": "rgba(64, 148, 208, 0.05)",
    "bannerBackgroundColor": "rgba(233, 246, 255, 1)",
    "bannerTextColor": "rgba(0, 0, 0, 1)"
  },
  "amac": {
    "config_id": "amac",
    "name": "amac",
    "employer_id": "9119-7864-7177",
    "landingPage": "/amac",
    "removeButtonsAfterLogin": true,
    "isEligibility": true,
    "headerDesktopLogologin": "assets/tenant-assets/mini-env/amac/amac-logo-login.png",
    "headerDesktopLogoTransparentlogin": "assets/tenant-assets/mini-env/amac/amac-tr-logo-login.png",
    "headerMobileLogoLogin" : "assets/tenant-assets/mini-env/amac/amac-mb-logo-login.svg",
    "headerMobileLogoTransparentLogin" : "assets/tenant-assets/mini-env/amac/amac-mb-logo-tr.svg",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/amac/amac-logo.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/amac/transparent-logo.png",
    "headerMobileLogo": "assets/tenant-assets/mini-env/amac/amac-responcive-logo.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/amac/transparent-logo.png",
    "footerLogo": "assets/tenant-assets/mini-env/pegasus-einstein/footer.svg",
    "facebookLink": "https://www.facebook.com/WoW-Health-Solutions-LLC-307406953311610",
    "twitterLink": "https://twitter.com/WoWHealthPlan1",
    "linkedinLink": "https://www.linkedin.com/company/wow-health-solutions",
    "membershipCodes": "Wow_Plus_Membership_Monthly",
    "primaryColor": "#4094D0",
    "primaryColorLight": "#E9F6FF",
    "primaryOutlineColor": "#D7ECFA",
    "purchaseURL": "",
    "backgroundColor": "#f3f6fb",
    "checkLogo": "assets/tenant-assets/mini-env/ssp/check-logo.svg",
    "secondaryColor": "#4094D0",
    "headerLogoWidthLogin" : 300,
    "headerLogoWidthMobLogin" : 148,
    "headerLogoWidth": 250,
    "headerLogoWidthMob": 148,
    "headerPhoneNumber": "+844-969-4325",
    "secondaryButtonColor": "#4094D0",
    "secondaryButtonText": "Member login",
    "secondaryButtonLink": "/auth/login",
    "primaryButtonColor": "#4094D0",
    "primaryButtonText": "Sign Me Up",
    "primaryButtonLink": "https://www.getcadrplus.com/order/checkout.cfm?id=861766&pdid=43663",
    "iconBackgroundColor": "rgba(186, 217, 239, 0.6)",
    "iconTextColor": "rgba(61, 150, 209, 1)",
    "iconForeground": "rgba(64, 148, 208, 0.05)",
    "bannerBackgroundColor": "rgba(233, 246, 255, 1)",
    "bannerTextColor": "rgba(0, 0, 0, 1)"
  },
  "jets-pizza": {
    "config_id": "jets-pizza",
    "name": "Jets Pizza",
    "landingPage": "/jets-pizza",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/jets-pizza/jets-pizza-logo.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/jets-pizza/jets-pizza-logo-transparent.svg",
    "headerMobileLogo": "assets/tenant-assets/mini-env/jets-pizza/jets-pizza-logo-mobile.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/jets-pizza/jets-pizza-logo-mobile-transparent.svg",
    "headerPhoneNumber": "+844-969-4325",
    "footerLogo": "assets/tenant-assets/mini-env/pegasus-einstein/footer.svg",
    "facebookLink": "https://www.facebook.com/WoW-Health-Solutions-LLC-307406953311610",
    "twitterLink": "https://twitter.com/WoWHealthPlan1",
    "linkedinLink": "https://www.linkedin.com/company/wow-health-solutions",
    "membershipCodes": "",
    "membershipPlanTypes": "WOW_PLUS_H2U_MEMBERSHIP,COMPREHENSIVE_CARE_H2U_MEMBERSHIP",
    "purchasePageUrl": "jets-pizza/#pricing-for-wow-plus-membership",
    "headerLogoWidth": 287,
    "headerLogoWidthMob": 155,
    "primaryButtonColor": "#FB8F3F",
    "primaryButtonText": "Sign Up",
    "primaryButtonLink": "jets-pizza/#pricing-for-wow-plus-membership",
    "secondaryButtonColor": "#FB8F3F",
    "secondaryButtonText": "Member login",
    "secondaryButtonLink": "/auth/login",
    "isSecondaryButtonDesign": true,
    "forcesDefaultLoginLogos": true
  },
  "prestige": {
    "config_id": "prestige",
    "agent_id": "6119-4352-6123",
    "agency_id": "5119-4213-3683",
    "name": "Prestige",
    "landingPage": "/prestige",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/prestige/prestige-logo.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/prestige/prestige-logo-transparent.svg",
    "headerMobileLogo": "assets/tenant-assets/mini-env/prestige/prestige-logo-mobile.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/prestige/prestige-logo-mobile-transparent.svg",
    "headerPhoneNumber": "+844-969-4325",
    "footerLogo": "assets/tenant-assets/mini-env/pegasus-einstein/footer.svg",
    "facebookLink": "https://www.facebook.com/WoW-Health-Solutions-LLC-307406953311610",
    "twitterLink": "https://twitter.com/WoWHealthPlan1",
    "linkedinLink": "https://www.linkedin.com/company/wow-health-solutions",
    "membershipCodes": "",
    "membershipPlanTypes": "COMPREHENSIVE_CARE_H2U_MEMBERSHIP",
    "membershipPlanTypesAll": "COMPREHENSIVE_CARE_H2U_MEMBERSHIP,WOW_PLUS_H2U_MEMBERSHIP,WOW_PRESTIGE_DENTAL_MEMBERSHIP",
    "secondaryButtonColor": "#FB8F3F",
    "secondaryButtonText": "Member login",
    "secondaryButtonLink": "/auth/login",
    "isSecondaryButtonDesign": true,
    "secondaryButtonDesignBackground": "rgba(203, 150, 59, 0.1)",
    "secondaryButtonDesignColor": "rgba(203, 150, 59, 1)",
    "primaryButtonColor": "rgba(203, 150, 59, 1)",
    "primaryButtonText": "Sign Up",
    "primaryButtonLink": "/buy-wow-plus-membership?plan=COMPREHENSIVE_CARE_H2U_MEMBERSHIP&selected=comprehensive",
    "primaryColor": "#CB963B",
    "primaryColorLight": "#F9F4EB",
    "primaryOutlineColor": "#CB963B33",
    "primaryHoverColor": "#CB963B",
    "secondaryColor": "#CB963B",
    "headerLogoWidth": 320,
    "headerLogoWidthMob": 155,
    "purchasePageUrl": "/buy-wow-plus-membership/#memberships",
    "hasPurchasePage": true,
    "forcesDefaultLoginLogos": true,
    "basicExcluded": true,
    "coupon":"prestige"
  },
  "cehas": {
    "config_id": "cehas",
    "agent_id": "6119-4229-4415",
    "agency_id": "5119-4133-8783",
    "name": "Fair Price",
    "landingPage": "/cehas",
    "isEligibility": true,
    "headerDesktopLogologin": "assets/tenant-assets/mini-env/cehas/cehas-logo-login.svg",
    "headerDesktopLogoTransparentlogin": "assets/tenant-assets/mini-env/cehas/cehas-tr-logo-login.svg",
    "headerMobileLogoLogin" : "assets/tenant-assets/mini-env/cehas/cehas-mb-logo-login.svg",
    "headerMobileLogoTransparentLogin" : "assets/tenant-assets/mini-env/cehas/cehas-mb-tr-logo-login.svg",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/cehas/cehas.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/cehas/cehas-transparent.svg",
    "headerMobileLogo": "assets/tenant-assets/mini-env/cehas/cehas-mobile.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/cehas/cehas-mobile-transparent.svg",
    "headerPhoneNumber": "+844-969-4325",
    "footerLogo": "assets/tenant-assets/mini-env/pegasus-einstein/footer.svg",
    "facebookLink": "https://www.facebook.com/WoW-Health-Solutions-LLC-307406953311610",
    "twitterLink": "https://twitter.com/WoWHealthPlan1",
    "linkedinLink": "https://www.linkedin.com/company/wow-health-solutions",
    "membershipCodes": "",
    "membershipPlanTypes": "WOW_PLUS_H2U_MEMBERSHIP,COMPREHENSIVE_CARE_H2U_MEMBERSHIP",
    "primaryColor": "#2D62BB",
    "primaryColor2": "#F0F5FD",
    "primaryColor3": "#E1EFFA",
    "primaryColorLight": "#F0F5FD",
    "secondaryColor": "#2D62BB",
    "headerLogoWidthLogin" : 300,
    "headerLogoWidthMobLogin" : 200,
    "headerLogoWidth": 106,
    "headerLogoWidthMob": 89,
    "backgroundColor": "#f3f6fb",
    "secondaryButtonColor": "rgba(45, 98, 187, 1)",
    "secondaryButtonText": "Member login",
    "secondaryButtonLink": "/auth/login",
    "primaryButtonColor": "#4094D0",
    "primaryButtonText": "First Time Login",
    "primaryButtonLink": "cehas-access-account",
    "iconBackgroundColor": "rgba(45, 98, 187, 0.1)",
    "iconTextColor": "rgba(45, 98, 187, 1)",
    "iconForeground": "rgba(45, 98, 187, 0.05)",
    "bannerBackgroundColor": "rgba(233, 246, 255, 1)",
    "bannerTextColor": "rgba(0, 0, 0, 1)",
    "removeButtonsAfterLogin": true
  },
  "ars": {
    "config_id": "ars",
    "removeButtonsAfterLogin": true,
    "isEligibility": true,
    "name": "ars",
    "landingPage": "/ars",
    "headerDesktopLogologin": "assets/tenant-assets/mini-env/ars/ars-logo.svg",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/ars/ars-logo.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/ars/tr-logo.svg",
    "headerMobileLogo": "assets/tenant-assets/mini-env/ars/rsa-mobile-logo.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/ars/mobile-transparent.svg",
    "headerPhoneNumber": "+844-969-4325",
    "footerLogo": "assets/tenant-assets/mini-env/pegasus-einstein/footer.svg",
    "facebookLink": "https://www.facebook.com/WoW-Health-Solutions-LLC-307406953311610",
    "twitterLink": "https://twitter.com/WoWHealthPlan1",
    "linkedinLink": "https://www.linkedin.com/company/wow-health-solutions",
    "membershipCodes": "",
    "primaryButtonColor": "#fb8f3f",
    "secondaryButtonColor": "#fb8f3f",
    "secondaryButtonText": "Member login",
    "secondaryButtonLink": "/auth/login",
    "primaryColor": "#fb8f3f",
    "primaryColor2": "#F0F5FD",
    "primaryColor3": "#E1EFFA",
    "primaryColorLight": "#F0F5FD",
    "primaryHoverColor": "rgba(251, 143, 63, 0.82)",
    "secondaryColor": "#784978",
    "headerLogoWidth": 270,
    "headerLogoWidthMob": 89,
    "backgroundColor": "#f3f6fb",
    "forcesDefaultLoginLogos": true
  },
  "fazolis": {
    "config_id": "fazolis",
    "name": "fazolis",
    "agent_id": "6119-4362-2203",
    "agency_id": "5119-4220-6298",
    "landingPage": "/fazolis",
    "headerPhoneNumber": "+844-969-4325",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/fazolis/fazolis.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/fazolis/fazolis-transparent.svg",
    "headerMobileLogo": "assets/tenant-assets/mini-env/fazolis/responcive.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/fazolis/responcive-transparent.svg",
    "footerLogo": "assets/tenant-assets/mini-env/fazolis/footer.svg",
    "facebookLink": "https://www.facebook.com/fazolis",
    "twitterLink": "https://twitter.com/WoWHealthPlan1",
    "linkedinLink": "https://www.linkedin.com/company/fazolis",
    "discountAmount": 5,
    "membershipPlanTypes": "WOW_PLUS_MEMBERSHIP",
    "headerLogoWidth": 274,
    "headerLogoWidthMob": 172,
    "purchasePageUrl": "fazolis/#pricing-for-wow-plus-membership",
    "primaryButtonColor": "#fb8f3f",
    "primaryButtonText": "Sign Up",
    "primaryButtonLink": "fazolis/#pricing-for-wow-plus-membership",
    "isSecondaryButtonDesign": true,
    "secondaryButtonColor": "#fb8f3f",
    "secondaryButtonText": "Member Login",
    "secondaryButtonLink": "/auth/login",
    "forcesDefaultLoginLogos": true
  },
  "tru": {
    "config_id": "tru",
    "name": "Tru",
    "isEligibility": true,
    "agent_id": "6119-4536-6716",
    "agency_id": "5119-4320-1838",
    "landingPage": "/tru",
    "removeButtonsAfterLogin": true,
    "headerDesktopLogologin": "assets/tenant-assets/mini-env/tru/tru-logo-login.png",
    "headerDesktopLogoTransparentlogin": "assets/tenant-assets/mini-env/tru/tru-tr-logo-login.svg",
    "headerMobileLogoLogin" : "assets/tenant-assets/mini-env/tru/tru-mb-logo-login.png",
    "headerMobileLogoTransparentLogin" : "assets/tenant-assets/mini-env/tru/tru-mb-tr-logo-login.svg",
    "headerPhoneNumber": "+844-969-4325",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/tru/tru-logo.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/tru/tru-logo-transparent.svg",
    "headerMobileLogo": "assets/tenant-assets/mini-env/tru/tru-responsive.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/tru/tru-responsive-transparent.svg",
    "footerLogo": "assets/tenant-assets/mini-env/tru/footer.svg",
    "facebookLink": "https://www.facebook.com/WoW-Health-Solutions-LLC-307406953311610",
    "twitterLink": "https://twitter.com/WoWHealthPlan1",
    "linkedinLink": "https://www.linkedin.com/company/wow-health-solutions",
    "membershipPlanTypes": "WOW_PLUS_MEMBERSHIP,COMPREHENSIVE_CARE",
    "headerLogoWidthLogin" : 250,
    "headerLogoWidthMobLogin" : 150,
    "headerLogoWidth": 68,
    "headerLogoWidthMob": 50,
    "purchasePageUrl": "/tru/#pricing-for-wow-plus-membership",
    "primaryColor": "#152177",
    "primaryColorLight": "#152177",
    "primaryOutlineColor": "#F3F4F8",
    "secondaryColor": "#152177",
    "primaryButtonColor": "#2D62BB",
    "primaryButtonText": "First Time Login",
    "primaryButtonLink": "/tru-access-account",
    "isSecondaryButtonDesign": true,
    "secondaryButtonDesignBackground":"#fff",
    "secondaryButtonDesignColor":"#152177",
    "secondaryButtonColor": "rgba(21, 33, 119, 1)",
    "secondaryButtonText": "Member login",
    "secondaryButtonLink": "/auth/login",
    "backgroundColor": "#FAFAFA",
    "iconBackgroundColor": "rgba(233, 246, 255, 1)",
    "iconTextColor": "rgba(21, 33, 119, 1)",
    "iconForeground": "rgba(45, 98, 187, 0.05)",
    "bannerBackgroundColor": "rgba(233, 246, 255, 1)",
    "bannerTextColor": "rgba(0, 0, 0, 1)"
  },
  "req-plus-membership": {
    "config_id": "req-plus-membership",
    "name": "Req Consulting",
    "employer_id": "",
    "agent_id": "6119-4604-4472",
    "agency_id": "5119-4357-1349",
    "landingPage": "/req-plus-membership",
    "headerPhoneNumber": "+844-969-4325",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/req-consulting/req-consulting-logo.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/req-consulting/req-consulting-logo-transparent.svg",
    "headerMobileLogo": "assets/tenant-assets/mini-env/req-consulting/req-consulting-logo-mobile.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/req-consulting/req-consulting-logo-mobile-transparent.svg",
    "footerLogo": "assets/tenant-assets/mini-env/req-consulting/footer.svg",
    "facebookLink": "https://www.facebook.com/WoW-Health-Solutions-LLC-307406953311610",
    "twitterLink": "https://twitter.com/WoWHealthPlan1",
    "linkedinLink": "https://www.linkedin.com/company/wow-health-solutions",
    "membershipCodes": "Plus_h2u_Monthly,Plus_h2u_Yearly",
    "membershipDentalCode": "Plus_Dental_h2u_Monthly,Plus_Dental_h2u_Yearly",
    "headerLogoWidth": 320,
    "headerLogoWidthMob": 154,
    "purchasePageUrl": "/req-plus-membership/#membership-section",
    "primaryColor": "#fb8f3f",
    "primaryButtonColor": "#2D62BB",
    "primaryButtonText": "Sign Up",
    "primaryButtonLink": "/req-plus-membership/#membership-section",
    "secondaryButtonColor": "#fb8f3f",
    "secondaryButtonText": "Member login",
    "secondaryButtonLink": "/auth/login",
    "isSecondaryButtonDesign": true,
    "forcesDefaultLoginLogos": true
  },
  "req-basic-membership": {
    "config_id": "req-basic-membership",
    "name": "Req Consulting",
    "employer_id": "",
    "agent_id": "6119-4607-2666",
    "agency_id": "5119-4359-7958",
    "landingPage": "/req-basic-membership",
    "headerPhoneNumber": "+844-969-4325",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/req-consulting/req-consulting-logo.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/req-consulting/req-consulting-logo-transparent.svg",
    "headerMobileLogo": "assets/tenant-assets/mini-env/req-consulting/req-consulting-logo-mobile.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/req-consulting/req-consulting-logo-mobile-transparent.svg",
    "footerLogo": "assets/tenant-assets/mini-env/req-consulting/footer.svg",
    "facebookLink": "https://www.facebook.com/WoW-Health-Solutions-LLC-307406953311610",
    "twitterLink": "https://twitter.com/WoWHealthPlan1",
    "linkedinLink": "https://www.linkedin.com/company/wow-health-solutions",
    "membershipCodes": "Basic_h2u_Monthly,Basic_h2u_Yearly",
    "membershipDentalCode": "Basic_Dental_h2u_Monthly,Basic_Dental_h2u_Yearly",
    "headerLogoWidth": 320,
    "headerLogoWidthMob": 154,
    "purchasePageUrl": "/req-basic-membership/#membership-section",
    "primaryColor": "#fb8f3f",
    "primaryButtonColor": "#2D62BB",
    "primaryButtonText": "Sign Up",
    "primaryButtonLink": "/req-basic-membership/#membership-section",
    "secondaryButtonColor": "#fb8f3f",
    "secondaryButtonText": "Member login",
    "secondaryButtonLink": "/auth/login",
    "isSecondaryButtonDesign": true,
    "forcesDefaultLoginLogos": true
  },
  "iac": {
    "config_id": "iac",
    "agent_id": "6119-4606-8329",
    "agency_id": "5119-4358-6579",
    "name": "IAC",
    "landingPage": "/iac",
    "headerDesktopLogologin": "assets/tenant-assets/mini-env/iac/iac-logo-login.png",
    "headerDesktopLogoTransparentlogin": "assets/tenant-assets/mini-env/iac/iac-tr-logo-login.png",
    "headerMobileLogoLogin" : "assets/tenant-assets/mini-env/iac/iac-logo-login-mb.png",
    "headerMobileLogoTransparentLogin" : "assets/tenant-assets/iac/iac-tr-logo-login-mb.png",
    "headerDesktopLogo": "assets/tenant-assets/mini-env/iac/iac-logo.svg",
    "headerDesktopLogoTransparent": "assets/tenant-assets/mini-env/iac/iac-logo-transparent.svg",
    "headerMobileLogo": "assets/tenant-assets/mini-env/iac/iac-logo.svg",
    "headerMobileLogoTransparent": "assets/tenant-assets/mini-env/iac/iac-logo-transparent.svg",
    "headerPhoneNumber": "+844-969-4325",
    "footerLogo": "assets/tenant-assets/mini-env/pegasus-einstein/footer.svg",
    "facebookLink": "https://www.facebook.com/WoW-Health-Solutions-LLC-307406953311610",
    "twitterLink": "https://twitter.com/WoWHealthPlan1",
    "linkedinLink": "https://www.linkedin.com/company/wow-health-solutions",
    "membershipCodes": "",
    "membershipPlanTypes": "IAC_PHARMACY_MEMBERSHIP,WOW_PLUS_H2U_MEMBERSHIP,COMPREHENSIVE_CARE_H2U_MEMBERSHIP",
    "primaryColor": "#465B72",
    "primaryOutlineColor": "#DAE3F3",
    "primaryButtonColor": "#4C5D78",
    "primaryButtonText": "Sign Up",
    "primaryButtonLink": "/buy-wow-plus-membership",
    "secondaryButtonColor": "#4C5D78",
    "secondaryButtonText": "Member login",
    "secondaryButtonLink": "/auth/login",
    "primaryColorLight": "#465B72",
    "secondaryColor": "#465B72",
    "headerLogoWidthLogin" : 300,
    "headerLogoWidthMobLogin" : 200,
    "headerLogoWidth": 266,
    "headerLogoWidthMob": 150,
    "backgroundColor": "#f3f6fb",
    "purchasePageUrl": "/buy-wow-plus-membership/#memberships",
    "hasPurchasePage": true,
    "iconBackgroundColor": "rgba(218, 227, 243, 1)",
    "iconTextColor": "rgba(70, 91, 114, 1)",
    "iconForeground": "rgba(240, 246, 255, 1)",
    "bannerBackgroundColor": "rgba(240, 246, 255, 1)",
    "bannerTextColor": "rgba(0, 0, 0, 1)"
  }
}